export enum Vendor {
  TWILIO = '0',
  TELNYX = '1',
  VONAGE = '2',
}

/** `vendorId` arrives as a number from GraphQL and the enum is a string, hence the coercion. */
export const isVendor = (vendorId: number | string, vendor: Vendor): boolean =>
  String(vendorId) === vendor;

export function vendorIdToName(vendorId) {
  switch (vendorId) {
    case null:
      return '';
    case Vendor.TWILIO:
      return 'Twilio';
    case Vendor.TELNYX:
      return 'Telnyx';
    case Vendor.VONAGE:
      return 'Vonage';
    default:
      console.warn(`Vendor name not configured for id=${vendorId}`);
      return 'Unknown';
  }
}
